import { render, staticRenderFns } from "./VuetifyLogo.vue?vue&type=template&id=2a790e64"
var script = {}
import style0 from "./VuetifyLogo.vue?vue&type=style&index=0&id=2a790e64&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a790e64')) {
      api.createRecord('2a790e64', component.options)
    } else {
      api.reload('2a790e64', component.options)
    }
    module.hot.accept("./VuetifyLogo.vue?vue&type=template&id=2a790e64", function () {
      api.rerender('2a790e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VuetifyLogo.vue"
export default component.exports